import { Component, h, Prop } from '@stencil/core';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-answer-customer',
  shadow: false,
})
export class UgcAnswerCustomer {
  @Prop() fontType: FontType = FontType.large;
  @Prop() customerNickname: string = '';
  @Prop() profileImageUrl: string = '';
  @Prop() customerProfileLink: string = '';

  render() {
    const isLargeType = this.fontType === FontType.large;
    return (
      <div class={`flex-row-start-center ${isLargeType ? 'gap-10' : 'gap-8'}`}>
        <ugc-qna-avatar
          profileImageUrl={this.profileImageUrl}
          customerProfileLink={this.customerProfileLink}
          class="flex-row-start-center"
        />
        <a href={`/me/${this.customerProfileLink}`} class={`fs-14 break-word hover-link-blue-dark bold`}>
          {this.customerNickname}
        </a>
      </div>
    );
  }
}
